import React, { useEffect, useState } from "react";
import PaymentsAppLayout from "../../Components/Molecules/PaymentsAppLayout";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import TabsSelector from "../../Components/Atoms/TabsSelector";
import PrivateComponentLoadingPage from "../LoadingPage/PrivateComponentLoadingPage";
import { useOnboardingStore } from "../../Store/Onboarding";
import { PaymentsIntegrationEnum } from "../../Contracts/Integration";
import IntegratedCustomersList from "./IntegratedCustomersList";
import UnmappedCustomersList from "./UnmappedCustomersList";

const CustomerListPage: React.FC = () => {
  const { getAdyenKYCDetails, adyenKYCDetails } = useOnboardingStore();
  const [currentActiveTab, setCurrentActiveTab] = useState(
    adyenKYCDetails?.connected_integration || ""
  );

  const { getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    getAdyenKYCDetails(getAccessTokenSilently);
  }, [getAccessTokenSilently, getAdyenKYCDetails]);

  const tabs = [
    ...(adyenKYCDetails?.connected_integration === PaymentsIntegrationEnum.Quickbooks
      ? [
          {
            key: PaymentsIntegrationEnum.Quickbooks,
            displayValue: "Quickbooks Clients"
          }
        ]
      : [
          {
            key: PaymentsIntegrationEnum.Xero,
            displayValue: "Xero Clients"
          }
        ]),
    { key: "unmapped", displayValue: "Unmapped Clients" }
  ];

  return (
    <PaymentsAppLayout>
      <div className="flex flex-col h-[calc(100vh-9rem)]">
        <TabsSelector
          tabs={tabs}
          currentActiveTab={currentActiveTab}
          setCurrentActiveTab={setCurrentActiveTab}
        />

        {adyenKYCDetails?.connected_integration &&
        currentActiveTab === adyenKYCDetails?.connected_integration ? (
          <IntegratedCustomersList connectedIntegration={adyenKYCDetails.connected_integration!} />
        ) : (
          <UnmappedCustomersList />
        )}
      </div>
    </PaymentsAppLayout>
  );
};

export default withAuthenticationRequired(CustomerListPage, {
  onRedirecting: () => <PrivateComponentLoadingPage />
});
